import { render, staticRenderFns } from "./org-card.vue?vue&type=template&id=31d121bb&scoped=true&"
import script from "./org-card.vue?vue&type=script&lang=js&"
export * from "./org-card.vue?vue&type=script&lang=js&"
import style0 from "./org-card.vue?vue&type=style&index=0&id=31d121bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d121bb",
  null
  
)

export default component.exports